import React from 'react';
import { JiraProjectData } from '../../../api/endpoints/jira';
import { LFC } from '../../../Legacy';
import { usePrompt } from '../../../ui';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../../popups/Popup';
import { CreateJiraIssueView } from './CreateJiraIssueView';

export const createJiraIssuePopup = (jiraProject: JiraProjectData, prefill?: any) => ({ ui: CreateJiraIssuePopup, args: { jiraProject, prefill } });

export const CreateJiraIssuePopup: LFC<PopupProps> = ({ action, dismiss, args }) => {
    const { jiraProject, prefill } = args;

    const promptRef = usePrompt({
        ignoreEnter: true,
        onAction: dismiss,
    });

    return <Popup ref={promptRef} p="1">
        <Popup.Title>
            Create Jira Issue
        </Popup.Title>
        <Popup.Content>
            <Flexer height=".5" />
            <CreateJiraIssueView jiraProject={jiraProject} prefill={prefill} onComplete={info => action(info)} />
        </Popup.Content>
        <Popup.Close onAction={dismiss} />
    </Popup>;
};
